import React, { useEffect, useRef, useState } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useNavigate } from "react-router-dom";
import { useGetAllChapterQuery } from "App/services/chapterServiceApi";
import { useGetQuestionChaptersQuery, useUpdateQuestionMutation } from "App/services/QuestionServiceApi";
import { Icon, IconButton } from "@mui/material";
// import JoditEditor from "jodit-react";
import { toast } from "react-toastify";
// import { config } from "components/EditorConfig";
import JoditEditor from "jodit-react";
import ChapterDragDrop from "./ChapterDragDrop";
import useFeatureEnabled from "components/FeatureToggle/useFeatureEnabled";

const EditQuestionFormDialogue = ({ question }) => {
  // const editorRef = useRef(null);
  const editor = useRef(null);
  const [open, setOpen] = useState(false);
  const [questionText, setQuestionText] = useState(question.que || "");
  const [answer, setAnswer] = useState(question.answer || "");
  const [videoLink, setVideoLink] = useState(question.video_link);
  const [chapterId, setChapterId] = useState(question.chapter_id || "");
  const [appliedChapters, setAppliedChapters] = useState([]);
  const multiChapterEnabled = useFeatureEnabled("multi_chapter_questions");
  const navigate = useNavigate();

  const {
    data: allChapters,
    error: questionsError,
    isLoading: questionsLoading,
  } = useGetAllChapterQuery();

  const {
    data: questionChapters,
  } = useGetQuestionChaptersQuery(question.id, { skip: !open });

  const [updateQuestion, { isLoading, isError, error }] = useUpdateQuestionMutation();

  useEffect(() => {
    if (questionChapters) {
      setAppliedChapters(questionChapters.map((c) => c.id));
    }
  }, [questionChapters]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleEditQuestion = async (event) => {
    event.preventDefault();


    if ((questionText, answer)) {
      let newQuestion = questionText.split('<p data-f-id="pbf" style="text-align: center; font-size: 14px; margin-top: 30px; opacity: 0.65; font-family: sans-serif;">Powered by <a href="https://www.froala.com/wysiwyg-editor?pb=1" title="Froala Editor">Froala Editor</a></p>')
      let newAnswer = answer.split('<p data-f-id="pbf" style="text-align: center; font-size: 14px; margin-top: 30px; opacity: 0.65; font-family: sans-serif;">Powered by <a href="https://www.froala.com/wysiwyg-editor?pb=1" title="Froala Editor">Froala Editor</a></p>')
      try {
        await updateQuestion({
          id: question.id,
          que: newQuestion[0],
          answer: newAnswer[0],
          video_link: videoLink,
          chapters: multiChapterEnabled ? appliedChapters : [chapterId].filter(Boolean),
        });
        toast.success("Question Successfully Updated!");

        handleClose();
      } catch (err) {
        toast.error("Something went wrong!!");
      }
    } else {
      toast.error("Required to question and answer");
    }
  };
  // const config = {
  //   controls: {
  //     lineHeight: {
  //       list: Jodit.atom([0.5,1, 2, 3, 3.5]),
  //     },
  //   },
  //   // other configurations...
  // };

  // const config = {
  //   controls: {
  //     lineHeight: {
  //       list: [1, 1.5, 2, 2.5, 3, 3.5],
  //       command: 'lineHeight',
  //     },
  //   },
  // };

  return (
    <React.Fragment>
      <IconButton onClick={handleClickOpen}>
        <Icon>edit</Icon>
      </IconButton>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          component: "form",
          onSubmit: handleEditQuestion,
        }}
      >
        <DialogTitle>Edit Question</DialogTitle>
        <DialogContent>
          <DialogContentText>Update the details of the question:</DialogContentText>

          <label>Question</label>
          {/* <Editor
            apiKey={`${EDITOR_API_KEY}`}
            onInit={(_evt, editor) => (editorRef.current = editor)}
            initialValue={questionText}
            init={init}
            onEditorChange={newContent => setAnswer(newContent)}
          /> */}
          <JoditEditor
            ref={editor}
            value={questionText} 
            // config={config}
            onChange={(newContent) => setQuestionText(newContent)}
          />
          {/* <EditorComponents
            content={questionText}
            handleChangeContent={(newContent) => setQuestionText(newContent)}
          /> */}

          <label>Answer</label>
          {/* <Editor
            apiKey={`${EDITOR_API_KEY}`}
            onInit={(_evt, editor) => (editorRef.current = editor)}
            initialValue={answer}
            init={init}
            onEditorChange={newContent => setAnswer(newContent)}
          /> */}

          {/* <EditorComponents
            content={answer}
            handleChangeContent={(newContent) => setAnswer(newContent)}
          /> */}

          <JoditEditor
            ref={editor}
            value={answer} 
            // config={config}
            onChange={(newContent) => setAnswer(newContent)}
          />
          <TextField
            margin="dense"
            id="videoLink"
            label="Video Link"
            fullWidth
            variant="outlined"
            value={videoLink}
            onChange={(e) => setVideoLink(e.target.value)}
          />
          <Box sx={{ mt: 2 }}>
            <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
              Chapter Applied
            </Typography>
            {questionsLoading ? (
              <Typography variant="body2" color="text.secondary">
                Loading chapters...
              </Typography>
            ) : multiChapterEnabled ? (
              <ChapterDragDrop
                chapters={allChapters || []}
                value={appliedChapters}
                onChange={setAppliedChapters}
              />
            ) : (
              <Typography variant="body2" color="text.secondary">
                {allChapters?.find((c) => c.id === Number(chapterId))?.name || "Single chapter"}
              </Typography>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button type="submit" disabled={isLoading} name="submit">
            Update {isLoading && "Loading..."}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default EditQuestionFormDialogue;
